import React from 'react'
import { connect } from 'react-redux'
import { DynamicModuleLoader } from 'redux-dynamic-modules'
import { Route } from 'react-router-dom'
import Loadable from 'react-loadable'
import modules, { init, enroll } from './modules'
import { getVerifyToken } from 'store/siteConfig'
import Loading from 'components/Loading'

export default function(route) {
  const GreenPoints = Loadable({
    loader: () => import('./GreenPoints'),
    render(loaded, props) {
      const Component = connect((state) => ({
        topicGreenPointsState: state.topicGreenPointsState,
        siteConfig: state.siteConfig
      }), {
        init,
        enroll,
        getVerifyToken
      })(loaded.default)
      return <Component {...props} />
    },
    loading: Loading
  })

  return (
    <Route
      path={`${route.match.path}/greenPoints`}
      render={routeProps => (
        <DynamicModuleLoader modules={[modules(routeProps.history)]}>
          <GreenPoints {...routeProps} />
        </DynamicModuleLoader>
      )}
    />
  )
}
